import styled from 'styled-components';

// remove associations positioning here,
// eventually remove it from the baked in render method to make this cleaner
import { jsx as _jsx } from "react/jsx-runtime";
const TrayWrapper = styled.div.withConfig({
  displayName: "RenderTray__TrayWrapper",
  componentId: "sc-5ru491-0"
})(["flex-grow:1;display:flex;justify-content:flex-end;.associations-positioning-wrapper{position:relative !important;right:auto !important;margin:0 !important;}"]);
const RenderTrayPassthrough = ({
  renderTray
}) => {
  return /*#__PURE__*/_jsx(TrayWrapper, {
    children: renderTray && renderTray({})
  });
};
export default RenderTrayPassthrough;